module.exports = __webpack_public_path__ + "static/media/emailbus.b0238fc6.png";